var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"title":_vm.$route.name}},[_c('Form',{staticClass:"pa-3"}),(_vm.tabs === 1)?_c('MainAccountBank',{staticClass:"pa-3"}):_vm._e(),_c('ModalViewAddress')],1)}
var staticRenderFns = []

export { render, staticRenderFns }